import React, {useRef, useState, useEffect} from 'react';
import styles from './MicroProfile.module.scss'
import NavToggle from "components/icons/navToggle/NavToggle";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import {buttonClick} from "utils/Helpers";

const MicroProfile = (props) => {

    const creator = props.creator;
    const info = useRef();
    const playerRefs = useRef([]);
    const [videos, setVideoPlaying] = useState([])
    const setRef = (ref, index) => { playerRefs.current[index] = ref; };

    useEffect(()=>{
        info.current.focus();
    }, [])


    function togglePlay(isPlaying, index){
        if(isPlaying){
            playerRefs.current[index].pause();
            setVideoPlaying(videos[index] = false);
        } else {
            playerRefs.current[index].play();
            setVideoPlaying(videos[index] = true);
        }
    }

    function buildGallery(){
        let index = 0;
        return creator.gallery.map((item, itemIndex)=>{
            if(index === 5) index = 0;

            let visual;
            if(item.images) visual = <ImageWrapper set={item.images} alt={`${creator.title} Originals Spotlight,  ${item.alt}`}/>;
            else {

                let playIcon = <span className={styles.play}/>;

                visual = (
                    <div>
                        <video ref={(player)=>setRef(player, itemIndex)} playsInline autobuffer={'true'} poster={item.poster}>
                            <source src={`${item.video}?micro=${item.alt}`} type="video/mp4"/>
                        </video>
                        { videos[itemIndex] && <div className={styles.close} onClick={() => togglePlay(true, itemIndex)}>
                            <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
                        </div>}
                        <div className={styles.playBar} onClick={()=>togglePlay(false, itemIndex)}>
                            <div className={styles.playText}>{playIcon}{item.videoTitle}</div>
                            <div className={styles.titleBg}><span/><span/></div>
                        </div>
                    </div>
                )
            }

            let display = (
                <div key={itemIndex} className={`${index !== 4 ? styles.square : styles.wide} ${styles.item}`}>
                    {visual}
                </div>
            );

            index++;

            return display

        })
    }

    return (
        <div className={styles.profile}>
            <ImageWrapper aria-hidden={true} className={styles.profileBg} set={creator.backgrounds} alt={`${creator.title} background`}/>
            <div className={`${styles.info}`}>
                <img tabIndex={-1} ref={info} aria-label={creator.title} className={styles.signature} src={creator.signature} alt={`${creator.title} signature`}/>
                <p dangerouslySetInnerHTML={{__html:creator.description}}/>
            </div>
            <div className={styles.gallery}>
                {buildGallery()}
            </div>
            <div tabIndex={0} role={'button'} aria-label={`Close microinfluencer profile`} onKeyDown={buttonClick} className={styles.close} onClick={()=>props.close(null)}><NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/></div>
        </div>
    )
};

export default MicroProfile
